import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from 'components/Avatar';
import {INSTANT_ADVISE_SESSION_CATEGORY} from 'configs/constants';
import React from 'react';
import NumberFormat from 'react-number-format';

export default function IncomingInstantAdviseSession({assignedSession, skill}) {
  const {category, price, duration, fromUser} = assignedSession;
  return (
    <Grid
      container
      direction="column"
      wrap="wrap"
      alignItems="center"
      spacing={1}
    >
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <Avatar avatar={fromUser?.avatar} size={10} />
          </Grid>
          <Grid item>
            <Typography variant="subtitle2" color="textSecondary">
              {fromUser?.nickname || 'ناشناس'}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h6" color="primary">
          مشاوره فوری با{' '}
          {skill
            ? 'متخصص ' + skill.title
            : INSTANT_ADVISE_SESSION_CATEGORY[category]}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="h6" color="primary">
          {duration} دقیقه‌ای
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="h6" color="primary">
          <NumberFormat
            value={price}
            displayType={'text'}
            thousandSeparator={true}
            suffix=" ریال"
          />
        </Typography>
      </Grid>
    </Grid>
  );
}
